module.exports = __webpack_public_path__ + "static/media/game-background-categorization.934ffda1.jpg";